import * as Yup from "yup";

export const validation = (t) =>
    Yup.object({
        code: Yup.string().required(t("registration.required")),
        password: Yup.string()
            .min(8, t("registration.passwordLength"))
            .max(255)
            .required(t("registration.required")),
        rePassword: Yup.string()
            .oneOf([Yup.ref("password"), null], t("registration.notMatch"))
            .required(t("registration.required")),
    });
